import { render, staticRenderFns } from "./product_answer_list.vue?vue&type=template&id=953ed1d2&scoped=true"
import script from "./product_answer_list.vue?vue&type=script&lang=js"
export * from "./product_answer_list.vue?vue&type=script&lang=js"
import style0 from "./product_answer_list.vue?vue&type=style&index=0&id=953ed1d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953ed1d2",
  null
  
)

export default component.exports